import { useContext } from "react";
import {
  PaymentDriverStatusContext,
  type PaymentDriverStatus,
} from "./PaymentDriverStatusContext";

/**
 * Read the active payment driver's gateway-agnostic status (init error /
 * loading). Returns the safe default ({ error: null, isLoading: false }) when
 * no driver is mounted, so callers don't need a driver present to call it.
 */
export function useDriverStatus(): PaymentDriverStatus {
  return useContext(PaymentDriverStatusContext);
}
